const reportDB = require("../../../../../components/report/report-db");
const snack = require("../../../../../components/snack/snack");
const customerProfitReport = require("../customer/customer-report-all-profit");
const { printHtmlInIframe } = require("./reportHub-report-print");
const { generateReceivableAll } = require("./reportHub-reportAll-template");
const { generateReceivableOneDocument } = require("./reportHub-reportOne-template");

const PHP_REPORT = "server/php/sql/report.php";

// Helper para mostrar errores de forma simplificada
const showError = (id = "downloadError") => snack.start({ act: "show", id });

// Constructor unificado del payload para las consultas
function buildDetail(report, filters, extraInf = {}) {
  const inf = { entity: "customer", report, ...extraInf };
  if (filters.startDate) inf.startDate = filters.startDate;
  if (filters.endDate) inf.endDate = filters.endDate;
  if (filters.useYear) inf.filterByYear = "1";
  
  return { inf };
}

export function getData(def, filters, helpers) {
  const actions = {
    "account-receivable-all": () => runGeneratorAll(filters),
    "account-receivable-one": () => runGeneratorOne(filters, helpers),
    "customer-profit-all": () => runProfitAll(),
    "customer-profit-one": () => runProfitOne(filters),
  };

  const action = actions[def.id];
  action ? action() : showError();
}

function runGeneratorAll(filters) {
  const detail = buildDetail("account-receivable-all", filters);

  reportDB.select(detail, PHP_REPORT, (data) => {
    if (!data?.length) return showError();
    printHtmlInIframe(generateReceivableAll(data));
  });
}

function runGeneratorOne(filters, helpers) {
  const dbid = filters.entityId || helpers.getSelectedCustomerDbid();
  
  if (!dbid) return showError("receivePaymentNoCustomer");

  const detailTop = buildDetail("account-receivable-all-one", filters, { dbid });

  reportDB.select(detailTop, PHP_REPORT, (topData) => {
    if (!topData?.length) return showError();

    const detailLines = buildDetail("account-receivable-one", filters, { id: dbid });

    reportDB.select(detailLines, PHP_REPORT, (tableData) => {
      printHtmlInIframe(generateReceivableOneDocument(topData, tableData || []));
    });
  });
}

function hubDetail() {
  return {
    reportPageRightId: "reportHub-report-output",
    skipReportPage: true,
    entity: "customer",
  };
}

function runProfitAll() {
  customerProfitReport.start({
    ...hubDetail(),
  });
}

function runProfitOne(filters) {
  if (!filters.entityId) return showError("receivePaymentNoCustomer");
  customerProfitReport.start({
    ...hubDetail(),
    source: "hub-one",
    dbid: filters.entityId,
  });
}